<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="组织建设" @navClick="navClick"></pageNav>
    <div class="main-content-area">
      <!--党群动态 -->
      <div class="dynamic-area" ref="area0">
        <div class="dynamic-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>01.</span>
                    <span>党群动态</span>
                  </div>
                  <div class="page-model-right flex align-center" @click="goPage(0)" v-if="dataList[0]&&dataList[0].length!=0">
                    <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                    <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                    <img src="../../assets/image/icon8.png" />
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="spe-show-list page-middle-content-row">
              <!-- pc -->
              <b-col xl="3" v-for="(item, index) in dataList[0]" :key="index" class="d-sm-none d-xl-block" @click="goDetail(item,0)">
                <div class="dynamic-item flex flex-column align-center">
                  <div class="dynamic-img flex  align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                  </div>
                  <div class="dynamic-info flex flex-column justify-between">
                    <div class="dynamic-title overHidden2">{{item.title}}</div>
                    <div class="dynamic-content">
                      <div class="dynamic-date">{{item.publishDate.substring(0,10).replace(/-/g,'/')}}</div>
                      <div class="dynamic-desc overHidden2">{{item.desc}}
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
              <!-- h5 -->
              <b-col :sm="12" v-for="(item, index) in dataList[0]" :key="index+22" class="d-sm-block d-xl-none" @click="goDetail(item,0)">
                <div class="sm-dynamic-item dynamic-item flex align-center">
                  <div class="dynamic-img flex align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                  </div>
                  <div class="sm-dynamic-info flex flex-column justify-between">
                    <div class="dynamic-title overHidden2">{{item.title}}</div>
                    <div class="dynamic-date">{{item.publishDate.substring(0,10).replace(/-/g,'/')}}</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 党建活动 -->
      <div class="activity-area" ref="area1">
        <div class="activity-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>02.</span>
                    <span>党建活动</span>
                  </div>
                  <div class="page-model-right flex align-center" @click="goPage(1)" v-if="dataList[1]&&dataList[1].length!=0">
                    <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                    <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                    <img src="../../assets/image/icon8.png" />
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="show-activity-list page-middle-content-row">
              <b-col xl="6" sm="6" v-for="(item, index) in dataList[1]" :key="index+33" @click="goDetail(item,1)">
                <!-- pc -->
                <div class="d-sm-none d-xl-block">
                  <div class="activity-item flex align-center justify-center">
                    <div class="activity-info">
                      <div class="activity-title overHidden">{{item.title}}</div>
                      <div class="activity-date">{{item.publishDate.substring(0,10).replace(/-/g,'/')}}</div>
                      <div class="activity-desc overHidden2">{{item.desc}}</div>
                    </div>
                    <div class="activity-right flex flex-column">
                      <div class="activity-img  flex align-center justify-center">
                        <img :src="$BaseUrl+item.image" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- h5 -->
                <div class="d-sm-block d-xl-none">
                  <div class="sm-activity-item activity-item flex flex-column align-center justify-center">
                    <div class="activity-img flex align-center justify-center">
                      <img :src="$BaseUrl+item.image" />
                    </div>
                    <div class="activity-info">
                      <div class="activity-title overHidden2">{{item.title}}</div>
                      <div class="activity-date">{{item.publishDate.substring(0,10).replace(/-/g,'/')}}</div>
                      <div class="activity-desc overHidden2">{{item.desc}}</div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 培训学习 -->
      <div class="train-area" ref="area2">
        <div class="train-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>03.</span>
                    <span>培训学习</span>
                  </div>
                  <div class="page-model-right flex align-center" @click="goPage(2)" v-if="dataList[2]&&dataList[2].length!=0">
                    <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                    <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                    <img src="../../assets/image/icon8.png" />
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <b-col xl="12">
                <div class="train-item flex" v-for="(item, index) in dataList[2]" :key="index" @click="goDetail(item,2)">
                  <div class="train-item-left flex align-center">
                    <div class="train-item-date d-sm-none d-xl-block">
                      <div class="flex flex-column">
                        <span>{{item.showTime?item.showTime[0]:''}}</span>
                        <span>{{item.showTime?item.showTime[1]:''}}</span>
                      </div>
                    </div>
                    <div class="train-item-content flex flex-column justify-between">
                      <div class="train-item-title overHidden2">
                        {{item.title}}
                      </div>
                      <div class="train-item-contentDate d-xl-none d-sm-block">
                        {{item.publishDate.substring(0,10).replace(/-/g,'/')}}
                      </div>
                      <!-- pc -->
                      <div class="train-item-desc d-sm-none d-xl-block">
                        <div class="overHidden2">{{item.desc}}</div>
                      </div>
                      <!-- h5 -->
                      <div class="train-item-desc overHidden d-sm-block d-xl-none">
                        <div class="overHidden">{{item.desc}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="train-item-img flex align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <Footer @goScroll="goScroll"></Footer>
  </div>
</template>
<script>
import { getOrganizationList } from '@/api/organizational'
export default {
  data() {
    return {
      navList: [{
        title: '党群动态'
      }, {
        title: '党建活动'
      }, {
        title: '培训学习'
      }],
      currentActive: 0,
      dataList: [[], [], []],
      topList:[],
      stopScroll:false,
      stopScrollTimeout:null
    }
  },
  mounted() {
    this.countViewCount()
    this.getOrganization()
  },
  destroyed(){
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    navClick({ item, index }) {
      this.stopScroll=true
      if(this.stopScrollTimeout)clearTimeout(this.stopScrollTimeout)
      this.currentActive = index
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollByRef(`area${index}`)
        }, 100)
        this.stopScrollTimeout = setTimeout(() => {
          this.stopScroll = false
        }, 1100)
      })
    },
    getOrganization() {
      getOrganizationList().then(res => {
        if (res.code == 200) {
          let temp = [[[], [], []]]
          res.data.forEach(v => {
            if (v.name == '党群动态') {
              temp.splice(0, 1, v.list)
            } else if (v.name == '党建活动') {
              temp.splice(1, 1, v.list)
            } else if (v.name == '培训学习') {
              temp.splice(2, 1, v.list)
            }
          })
          this.dataList = temp
          if (this.dataList[0].length > 4) {
            this.dataList[0] = this.dataList[0].slice(0, 4)
          }
          if (this.dataList[1] && this.dataList[1].length > 4) {
            this.dataList[1] = this.dataList[1].slice(0, 4)
          }
          if (this.dataList[2] && this.dataList[2].length > 3) {
            this.dataList[2] = this.dataList[2].slice(0, 3)
          }
          this.dataList[0] = this.dataList[0].map(v => {
            v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return v
          })
          this.dataList[1] = this.dataList[1].map(v => {
            v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return v
          })
          this.dataList[2] = this.dataList[2].map(t => {
            let d = t.publishDate.substring(0, 10).split('-')
            t.showTime = [d[0], `${d[1]}-${d[2]}`]
            t.desc = (t.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return t
          })
          this.$nextTick(() => {
            if (this.$route.query.to != undefined) {
              this.navClick({ index: Number(this.$route.query.to) })
              setTimeout(()=>{
                window.addEventListener("scroll", this.handleScroll)
              },1000)
            }else{
              window.addEventListener("scroll", this.handleScroll)
            }
          })
          // console.log(this.dataList)
        }
      })
    },
    goPage(index) {
      let temp = this.dataList[index][0]
      this.$router.push({ path: '/newsList?categoryOne=' + temp.categoryOne + '&categoryTwo=' + temp.categoryTwo + '&type=orga&scroll=' + index })
    },
    goDetail(item, index) {
      let pageName = ['党群动态', '党建活动', '培训学习'][index]
      this.$router.push({ path: `/newsDetail?contentId=${item.contentId}&type=orga&=pageName=${pageName}&scroll=${index}` })
    },
    goScroll(index) {
      this.navClick({ index: Number(index) })
    },
    handleScroll(e){
      if(this.stopScroll){
        return
      }
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if(this.topList.length==0){
        for(let i=0;i<3;i++){
          this.topList.push(this.$refs[`area${i}`].offsetTop-200)
        }
      }
      let temp=this.currentActive
      let result=this.topList.reduce((res,curV,curVindex)=>{
        if(nowTop>=curV){
          res=curVindex
        }
        return res
      },temp)
      // 获取距离顶部的距离
      let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      // 获取可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      if(scrollTop+windowHeight>=scrollHeight){
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部                    
        result=this.topList.length-1
      }
      this.currentActive=result
      // console.log(this.topList)
    }
  }
}
</script>
<style lang="scss" scoped>
// 党建动态
.dynamic-area {
  background-image: url("../../assets/image/bg13.png");
  background-size: cover;
  width: 100%;
  min-height: 487px;
  padding-bottom: 60px;
  padding-top: 60px;

  .dynamic-box {
    max-width: 1200px;
    margin: 0 auto;

    .page-model-title-line {
      margin-bottom: 30px;
    }
    .spe-show-list {
      > div {
        padding: 0;
      }
    }
    .dynamic-item {
      cursor: pointer;
      user-select: none;
      width: calc(100% - 15px);
      box-shadow: 0px 0 30px 0px rgba(10, 49, 128, 0.1);
      .dynamic-img {
        // width: 210px;
        width: 100%;
        height: 158px;
        background: #fff;
        overflow: hidden;
        img {
          width: 100%;
          // width: 210px;
          object-fit: cover;
          height: 158px;
        }
      }

      .dynamic-info {
        // width: 210px;
        width: 100%;
        background: #fff;
        padding: 15px;
        min-height: 180px;

        .dynamic-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 36px;
          min-height: 72px;
        }

        .dynamic-content {
          .dynamic-date {
            font-family: "SourceHanSansCN-Regular";
            font-size: 20px;
            color: #999999;
            line-height: 30px;
            margin-bottom: 10px;
          }

          .dynamic-desc {
            font-size: 20px;
            color: #666666;
            line-height: 30px;
            min-height: 60px;
          }
        }
      }
    }

    .dynamic-item:hover {
      .dynamic-img {
        background: #1566d4;
      }

      .dynamic-info {
        background: #1566d4;
      }

      .dynamic-title {
        color: #fff;
      }

      .dynamic-info {
        .dynamic-content {
          .dynamic-date {
            color: rgba(255, 255, 255, 0.8);
          }
        }

        .dynamic-desc {
          color: rgba(255, 255, 255, 1);
        }
      }

      .sm-dynamic-info {
        background: #1566d4;

        .dynamic-title {
          color: #fff;
        }

        .dynamic-date {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .sm-dynamic-item {
      width: 100%;
      box-shadow: 0px 0 30px 0px rgba(10, 49, 128, 0.1);
      margin-bottom: 20px;
      padding: 0 15px;

      .dynamic-img {
        width: 256px;
        height: 144px;
        flex-shrink: 0;

        img {
          width: 256px;
          height: 144px;
        }
      }

      .sm-dynamic-info {
        flex: 1;
        min-height: auto;
        height: 144px;
        background: #fff;
        padding: 20px;

        .dynamic-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 20px;
          color: #333333;
        }

        .dynamic-date {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 18px;
          color: #999999;
        }
      }
    }
  }
}

// 党建活动
.activity-area {
  background-image: url("../../assets/image/bg14.png");
  background-size: cover;
  width: 100%;
  min-height: 444px;
  padding-bottom: 60px;
  padding-top: 60px;
  .show-activity-list {
    > div {
      padding: 0;
    }
  }
  .activity-box {
    max-width: 1200px;
    margin: 0 auto;

    .page-model-title-line {
      margin-bottom: 30px;
    }

    .activity-item {
      // width: 100%;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      margin-bottom: 15px;
      user-select: none;
      cursor: pointer;
      margin-right: 15px;
      height: 158px;

      .activity-info {
        background: #fff;
        height: 158px;
        padding: 12px;
        flex: 1;
        min-width: 0;

        .activity-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          // line-height: 36px;
        }

        .activity-date {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          // line-height: 30px;
          margin-top: 10px;
          margin-bottom: 5px;
        }

        .activity-desc {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 18px;
          color: #666666;
          min-height: 45px;
        }
      }

      .activity-right {
        flex-shrink: 0;

        .activity-img {
          width: 280px;
          height: 158px;
          overflow: hidden;
          background: #fff;

          img {
            width: 280px;
            object-fit: cover;
            height: 158px;
          }
        }
      }
    }
    .activity-item:hover {
      .activity-info {
        background-color: #1566d4;

        .activity-title {
          color: #fff;
        }

        .activity-date {
          color: rgba(255, 255, 255, 0.8);
        }

        .activity-desc {
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }

    .sm-activity-item {
      width: 100%;
      padding: 0 7px 0 15px;
      margin-right: 0;
      // padding: 0 15px;

      .activity-img {
        width: 100%;
        min-height: 192px;
        flex-shrink: 0;
        background: #fff;
        overflow: hidden;
        max-width: 999px!important;

        img {
          width: 100%;
          object-fit: cover;
          height: 192px;
        }
      }

      .activity-info {
        width: 100%;
        flex: 1;
        min-width: 0;

        .activity-title {
          min-height: 54px;
        }
      }
    }
  }
}

// 培训学习
.train-area {
  background-image: url("../../assets/image/bg9.png");
  background-size: cover;
  width: 100%;
  min-height: 700px;
  padding-bottom: 60px;
  padding-top: 60px;

  .train-box {
    max-width: 1200px;
    margin: 0 auto;

    .train-item {
      width: 100%;
      background: #fff;
      margin-bottom: 15px;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      // border: 1px solid rgba(153, 153, 153, 0.5);
      overflow: hidden;
      cursor: pointer;

      .train-item-left {
        padding: 20px 0;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }

      &-date {
        padding: 35px 0;
        min-width: 170px;
        border-right: 3px solid rgba(153, 153, 153, 0.5);
        flex-shrink: 0;

        > div {
          > span:first-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 33px;
            color: #333333;
            line-height: 41px;
          }

          > span:last-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 22px;
            color: #666666;
            line-height: 25px;
          }
        }
      }

      &-content {
        height: 174px;
        padding: 10px 20px;
        flex: 1;
        min-width: 0;
        overflow: hidden;

        .train-item-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }

        .train-item-contentDate {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #999999;
        }

        .train-item-desc {
          font-family: "SourceHanSansCN-Regular";
          font-size: 20px;
          color: #666666;
        }
      }

      &-img {
        width: 380px;
        height: 214px;
        flex-shrink: 0;

        img {
          object-fit: cover;
          width: 380px;
          height: 214px;
        }
      }
    }

    .train-item:first-of-type {
      margin-top: 30px;
    }

    .train-item:last-of-type {
      margin-bottom: 0;
    }

    .train-item:hover {
      background-color: #1566d4;

      .train-item-date {
        > div {
          > span:first-of-type {
            color: #fff;
          }

          > span:last-of-type {
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }

      .train-item-content {
        .train-item-title {
          color: #fff;
        }

        .train-item-desc {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
}

// 移动端
@media (min-width: 576px) and (max-width: 1200px) {
  // 党群动态
  .dynamic-area {
    .sm-dynamic-item {
      .sm-dynamic-info {
        padding: 10px 20px !important;
        .dynamic-title {
          font-size: 26px !important;
        }
        .dynamic-date {
          font-size: 20px !important;
        }
      }
    }
  }
  // 党建活动
  .activity-area {
    .activity-box {
      .sm-activity-item {
        height: auto !important;
        .activity-img {
          max-width: 341px;
          height: 192px;
        }
        .activity-info {
          .activity-title {
            font-size: 26px;
            min-height: 78px;
          }
          .activity-date {
            font-size: 20px;
          }
          .activity-desc {
            font-size: 24px;
            min-height: 72px;
          }
        }
      }
    }
  }

  // 培训学习
  .train-area {
    .train-box {
      .train-item {
        height: 192px;
        .train-item-img {
          width: 341px !important;
          height: 192px !important;
          img {
            width: 341px !important;
            height: 192px !important;
          }
        }
        .train-item-content {
          .train-item-title {
            font-size: 26px;
          }
          .train-item-contentDate {
            font-size: 20px;
          }
          .train-item-desc {
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>